<template>
  <div class="system_name" style="cursor: pointer;">
    <span>
      {{ title }}
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: sessionStorage.getItem('companyNM'),
      dee: sessionStorage.getItem('dee'),
    }
  },
  created() {
    this.list = this.$route.matched
  },
  watch: {
    //监听
  },
  methods: {
    sgourl(url) {
      this.$router.push(url)
    },
    changeData() {
      if (sessionStorage.getItem('dee') == 1) {
        sessionStorage.setItem('dee', 2)
        this.$forceUpdate()
      } else {
        sessionStorage.setItem('dee', 1)
        this.$forceUpdate()
      }
    },
  },
  mounted() {

  }
}
</script>
<style scoped>
.system_name {
  line-height: 54px;
  font-size: 18px;
  font-weight: 600;
  color: rgba(36, 153, 255, 1);
}
</style>
